import store from '@/store/BookingStore';
import axios, { AxiosResponse } from 'axios';

const subscribeToCRMnewsLetter = async (email: string, optin_mail: boolean, optin_sms: boolean): Promise<boolean> => {
    const url = `https://api-migdal.travelfactory.fr/public/crm/subscribe/v2`;
    try {
        const response: AxiosResponse<boolean> = await axios.post(url, { email, optin_mail, optin_sms, website: window.env.VUE_APP_WEBSITE }, {
            headers: {
                'accept-language': store.getters.getLocale,
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (err) {
        console.error(err);
        return false;
    }
};

export default subscribeToCRMnewsLetter;